module.exports = __webpack_public_path__ + "static/media/sport-start-bleeps.d02f9ada.wav";